import React from 'react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';  
import { Carousel as Slide } from "flowbite-react";
interface CarouselProps {
  images: string[];
}

const Carousel: React.FC<CarouselProps> = ({ images }) => {

  return (
    <div style={{
      width: "100%",
      aspectRatio: "16/5"
    }}>
      <Slide>
      {images.map((image, index) => (
          <img key={index} src={image} alt={`Slide ${index + 1}`} style={{ width: '100%' }} />
      ))}

      </Slide>
    </div>
  )
};

export default Carousel;
